import { ActionIcon, ActionIconProps, PolymorphicComponentProps } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import { NavigateOptions, useNavigate, useRouter } from "@tanstack/react-router";
import React from "react";

type BackButtonProps = PolymorphicComponentProps<"button", ActionIconProps> & {
    nav?: NavigateOptions;
};

export const BackButton = (props: BackButtonProps) => {
    const router = useRouter();
    const nav = useNavigate();

    function handleClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        if (typeof props.onClick == "function") {
            props.onClick(e);
            return;
        }

        if (!!props.nav) {
            void nav(props.nav);
            return;
        }

        router.history.back();
    }

    return (
        <ActionIcon variant="transparent" onClick={handleClick} {...props} aria-label="Back">
            {props.children ?? <IconChevronLeft size={16} strokeWidth={4} />}
        </ActionIcon>
    );
};
